export const settings = {
    ApiUrl:
        window.location.hostname === "localhost" ? "http://localhost:6368/api/"
            : (window.location.hostname === "atg.edotsis.net" ? "http://api.edotsis.net/api/"
                : (window.location.hostname === "at.onakgrup.com" ? "https://atapi.onakgrup.com/api/"
                    : "https://api.groupatg.com/api/"))
}